import "./NavbarLeft.scss"

const NavbarLeft = () => {
    return (
        <div className="navbar-left">
            {/* <img className="bluestate-logo" src="/assets/logo/bluestate_long_logo.png" alt="logo" /> */}
            <p>BLUESTATE</p>
        </div >
    )
}

export default NavbarLeft;